/** Display hygiene for strings that came from a model or a person and are echoed into a Verdict. */

const MAX_DISPLAY_LEN = 64;
/** Invisible characters (soft hyphen, zero-width, LRM/RLM, bidi embeddings/overrides/isolates, BOM): never part of a value. */
export const INVISIBLE_CHARS = '\u00AD\u061C\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u2069\uFEFF';
/** For display: C0 + DEL + C1 controls and line/paragraph separators too, plus INVISIBLE_CHARS. */
const HIDDEN = new RegExp(`[\\u0000-\\u001F\\u007F-\\u009F\\u2028\\u2029${INVISIBLE_CHARS}]`, 'g');

/** Strip invisible/control characters, trim, and cap at 64 characters plus an ellipsis. null stays null. */
export function sanitizeDisplay(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const s = String(raw).replace(HIDDEN, '').trim();
  if (s.length <= MAX_DISPLAY_LEN) return s;
  const cut = s.slice(0, MAX_DISPLAY_LEN);
  const last = cut.charCodeAt(cut.length - 1);
  const whole = last >= 0xd800 && last <= 0xdbff ? cut.slice(0, -1) : cut;
  return `${whole}…`;
}
